module.exports = __webpack_public_path__ + "static/2_QUEEN-3f6aaf2fc314d4c9d2baf00907050bc2.png";